import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface TrdRcvInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function TrdRcvInternalControls({
  onBack,
  setActiveSection,
  controlsListSection,
}: TrdRcvInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Trade Receivables"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}

